import { createApp } from 'vue'
import App from './App.vue'
// 1. 导入路由实例（你的 router/index.js）
import router from './router'

// 2. 通过 use(router) 注册路由
createApp(App)
    .use(router) // 关键：注册 Vue Router，让 <router-view> 生效
    .mount('#app')